import { render, staticRenderFns } from "./SupplierComponent.vue?vue&type=template&id=3d7c7bf3&scoped=true&"
import script from "./SupplierComponent.vue?vue&type=script&lang=js&"
export * from "./SupplierComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7c7bf3",
  null
  
)

export default component.exports